import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimationControls, useInView, useReducedMotion } from 'framer-motion';

// Each character has a real articulated hand cutout. Keep Splash unmirrored:
// his raised hand already points inward, and his chest emblem stays readable.
export const WaveMascot = ({ replay = 0, loop = false, testId = 'splash-wave', className = '', label = 'Splash waving hello', prefix, origin }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { amount: 0.35 });
    const reduced = useReducedMotion();
    const controls = useAnimationControls();
    const [ready, setReady] = useState(false);
    const [pageVisible, setPageVisible] = useState(() => typeof document === 'undefined' || !document.hidden);
    const lastPlay = useRef(null);

    useEffect(() => {
        const updateVisibility = () => setPageVisible(!document.hidden);
        document.addEventListener('visibilitychange', updateVisibility);
        updateVisibility();
        return () => document.removeEventListener('visibilitychange', updateVisibility);
    }, []);

    useEffect(() => {
        if (reduced || !inView || !pageVisible || !ready) {
            controls.stop();
            controls.set({ rotate: 0 });
            return;
        }
        if (!loop && lastPlay.current === replay) return;
        lastPlay.current = replay;
        controls.start({
            rotate: [0, -10, 9, -8, 7, 0],
            transition: { duration: 1.6, ease: 'easeInOut', repeat: loop ? Infinity : 0, repeatDelay: loop ? 0.3 : 0 },
        });
        return () => controls.stop();
    }, [controls, inView, loop, pageVisible, ready, reduced, replay]);

    return (
        <div ref={ref} role="img" aria-label={label} className={`sp-wave-figure ${className}`} data-testid={testId}>
            <img src={prefix ? `${prefix}-body.png` : '/mascot/splash-waving-body.png'} alt="" aria-hidden="true" width="400" height="596" loading="lazy" draggable="false" className="sp-wave-body" />
            <motion.img src={prefix ? `${prefix}-hand.png` : '/mascot/splash-wave-hand.png'} alt="" aria-hidden="true" width="400" height="596" loading="lazy" draggable="false" onLoad={() => setReady(true)} animate={controls} style={origin ? { transformOrigin: origin } : undefined} className="sp-wave-hand" data-testid={`${testId}-hand`} />
        </div>
    );
};
